const actions = {
  EDIT_ROLE_ACTIONS_PROPERTY: 'EDIT_ROLE_ACTIONS_PROPERTY',
  FETCH_ROLE_ACTIONS: 'FETCH_ROLE_ACTIONS',
  FETCH_ROLE_ACTIONS_ERROR: 'FETCH_ROLE_ACTIONS_ERROR',
  FETCH_ROLE_ACTIONS_SUCCESS: 'FETCH_ROLE_ACTIONS_SUCCESS',
  HIDE_ROLE_ACTIONS: 'HIDE_ROLE_ACTIONS',
  REFRESH_ROLE_ACTIONS: 'REFRESH_ROLE_ACTIONS',
  SHOW_ROLE_ACTIONS: 'SHOW_ROLE_ACTIONS',
  UPDATE_ROLE_ACTIONS: 'UPDATE_ROLE_ACTIONS',
  UPDATE_ROLE_ACTIONS_ERROR: 'UPDATE_ROLE_ACTIONS_ERROR',
  UPDATE_ROLE_ACTIONS_SUCCESS: 'UPDATE_ROLE_ACTIONS_SUCCESS',
};

export default actions;
